/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Address,
  FlowerCollectionProduct,
  IncludedResource,
  Order,
  Subscription,
  SubscriptionContract,
  SubscriptionPlacement,
  SubscriptionSchedule,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Subscriptions<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags subscription_in_bulk_products
   * @name DeleteSubscriptionsSubscriptionIdInBulkProductsId
   * @summary 定期便から合わせ買い商品を削除する
   * @request DELETE:/subscriptions/{subscription_id}/in_bulk_products/{id}
   */
  deleteSubscriptionsSubscriptionIdInBulkProductsId = (
    subscriptionId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/subscriptions/${subscriptionId}/in_bulk_products/${id}`,
      method: "DELETE",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscriptions
   * @name GetSubscriptions
   * @summary 契約している定期便一覧を返す
   * @request GET:/subscriptions
   */
  getSubscriptions = (params: RequestParams = {}) =>
    this.request<
      {
        data: Subscription[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags in_bulk_purchasables
   * @name GetSubscriptionsInBulkPurchasables
   * @summary 定期便に合わせ買いできる商品を返す
   * @request GET:/subscriptions/in_bulk_purchasables
   */
  getSubscriptionsInBulkPurchasables = (
    query?: {
      /**
       * 定期便の種類
       * @default "lossless_bouquet"
       */
      category?: "lossless_bouquet" | "green";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: FlowerCollectionProduct[];
        included?: IncludedResource[];
      },
      any
    >({
      path: `/subscriptions/in_bulk_purchasables`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_addresses
   * @name GetSubscriptionsSubscriptionIdAddress
   * @summary 定期便の配送先住所を返す
   * @request GET:/subscriptions/{subscription_id}/address
   */
  getSubscriptionsSubscriptionIdAddress = (
    subscriptionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/address`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_orders
   * @name GetSubscriptionsSubscriptionIdOrders
   * @summary 定期便の注文一覧を取得する
   * @request GET:/subscriptions/{subscription_id}/orders
   */
  getSubscriptionsSubscriptionIdOrders = (
    subscriptionId: string,
    query?: {
      /**
       * 関連するリソース
       * @default []
       */
      include?: (
        | "user"
        | "address"
        | "order_items"
        | "order_items.orderable"
        | "order_items.shipping_statuses"
      )[];
      /**
       * ページ番号
       * @default 1
       */
      page?: string;
      /**
       * 1ページあたりの表示件数
       * @default null
       */
      per_page?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Order[];
        included?: IncludedResource[];
      },
      any
    >({
      path: `/subscriptions/${subscriptionId}/orders`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags placements
   * @name GetSubscriptionsSubscriptionIdPlacements
   * @summary 指定された定期便の注文予定一覧を近い順に返す
   * @request GET:/subscriptions/{subscription_id}/placements
   */
  getSubscriptionsSubscriptionIdPlacements = (
    subscriptionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionPlacement[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/placements`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_products
   * @name GetSubscriptionsSubscriptionIdProduct
   * @summary 定期便の商品情報を返す
   * @request GET:/subscriptions/{subscription_id}/product
   */
  getSubscriptionsSubscriptionIdProduct = (
    subscriptionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: FlowerCollectionProduct;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/product`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_schedules
   * @name GetSubscriptionsSubscriptionIdSchedulesPlan
   * @summary 指定された条件に変更したときの発送スケジュールを返す
   * @request GET:/subscriptions/{subscription_id}/schedules/plan
   */
  getSubscriptionsSubscriptionIdSchedulesPlan = (
    subscriptionId: string,
    query: {
      /** 月の発送回数 */
      per_month: string;
      /** 発送曜日（2: 火曜日, 5: 金曜日） */
      weekday: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionSchedule[];
        included?: IncludedResource[];
      },
      any
    >({
      path: `/subscriptions/${subscriptionId}/schedules/plan`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_addresses
   * @name PostSubscriptionsAddresses
   * @summary 定期便用の住所を新規作成する
   * @request POST:/subscriptions/addresses
   */
  postSubscriptionsAddresses = (
    data: {
      /** 市区町村と住所 */
      city_and_street: string;
      /**
       * 住所の種別
       * @default null
       */
      kind?: string;
      /** 氏名 */
      name: string;
      /**
       * マンション名、部屋番号など
       * @default ""
       */
      others?: string;
      /**
       * 電話番号
       * @default null
       */
      phone_number?: string;
      /** 郵便番号 */
      postal_code: string;
      /**
       * 送り主の氏名
       * @default null
       */
      sender_name?: string;
      /** 都道府県 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/addresses`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description pendingの次回注文はキャンセルされるが、すでに注文がつくられている場合は配送まで進む。
   *
   * @tags subscriptions
   * @name PostSubscriptionsIdCancel
   * @summary 定期購入を解約する
   * @request POST:/subscriptions/{id}/cancel
   */
  postSubscriptionsIdCancel = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        data: Subscription;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${id}/cancel`,
      method: "POST",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_sessions
   * @name PostSubscriptionsSessions
   * @summary ログインまたは会員登録する
   * @request POST:/subscriptions/sessions
   */
  postSubscriptionsSessions = (
    data: {
      /** メールアドレス */
      email: string;
      /** パスワード */
      password: string;
      /** @default "0" */
      signup?: "0" | "1";
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/subscriptions/sessions`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_in_bulk_products
   * @name PostSubscriptionsSubscriptionIdInBulkProducts
   * @summary 定期便に合わせ買い商品を追加する
   * @request POST:/subscriptions/{subscription_id}/in_bulk_products
   */
  postSubscriptionsSubscriptionIdInBulkProducts = (
    subscriptionId: string,
    data: {
      /** 商品ID */
      flower_collection_product_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: FlowerCollectionProduct;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/in_bulk_products`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags placements
   * @name PostSubscriptionsSubscriptionIdPlacementsIdSkip
   * @summary 指定された注文予定をスキップする
   * @request POST:/subscriptions/{subscription_id}/placements/{id}/skip
   */
  postSubscriptionsSubscriptionIdPlacementsIdSkip = (
    subscriptionId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionPlacement;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/placements/${id}/skip`,
      method: "POST",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags placements
   * @name PostSubscriptionsSubscriptionIdPlacementsIdUnskip
   * @summary 指定された注文予定のスキップを解除する
   * @request POST:/subscriptions/{subscription_id}/placements/{id}/unskip
   */
  postSubscriptionsSubscriptionIdPlacementsIdUnskip = (
    subscriptionId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionPlacement;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/placements/${id}/unskip`,
      method: "POST",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_addresses
   * @name PutSubscriptionsSubscriptionIdAddress
   * @summary 定期便の配送先住所を更新する
   * @request PUT:/subscriptions/{subscription_id}/address
   */
  putSubscriptionsSubscriptionIdAddress = (
    subscriptionId: string,
    data: {
      /** 市区町村と住所 */
      city_and_street: string;
      /**
       * 住所の種別
       * @default null
       */
      kind?: string;
      /** 氏名 */
      name: string;
      /**
       * マンション名、部屋番号など
       * @default ""
       */
      others?: string;
      /**
       * 電話番号
       * @default null
       */
      phone_number?: string;
      /** 郵便番号 */
      postal_code: string;
      /**
       * 送り主の氏名
       * @default null
       */
      sender_name?: string;
      /** 都道府県 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/address`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_contracts
   * @name PutSubscriptionsSubscriptionIdContract
   * @summary 定期便の契約週を変更する
   * @request PUT:/subscriptions/{subscription_id}/contract
   */
  putSubscriptionsSubscriptionIdContract = (
    subscriptionId: string,
    data: {
      /** 月の発送回数 */
      per_month: string;
      /** 発送曜日（2: 火曜日, 5: 金曜日） */
      weekday: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionContract[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscriptions/${subscriptionId}/contract`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
}
